export default ($http) => ({
  fetch (lessonId, yearId) {
    return $http.get(`lessons/${lessonId}`, { query: { ...(yearId ? { yearId } : {}) } })
  },
  fetchPublicSharedLink (linkId, yearId) {
    return $http.get(`shared-lessons/${linkId}`, { query: { ...(yearId ? { yearId } : {}) } })
  },
  save (lessonId, lesson) {
    return $http.put(`lessons/${lessonId}`, { body: lesson })
  },
  updateSettings(lessonId, payload) {
    return $http.put(`lessons/${lessonId}/settings`, { body: payload })
  },
  saveAndUnlock (lessonId, lesson) {
    return $http.put(`lessons/${lessonId}/save-and-unlock`, { body: lesson })
  },
  saveAndUnlockOnPageLeave (lessonId, lesson) {
    return $http.put(`lessons/${lessonId}/save-and-unlock-page-leave`, { body: lesson })
  },
  delete (lessonId) {
    return $http.delete(`lessons/${lessonId}`)
  },
  copy (payload) {
    return $http.post('lessons/copy', { body: payload })
  },
  lock (lessonId) {
    return $http.post(`lessons/${lessonId}/lock`)
  },
  updateLock (lessonId, lockId) {
    return $http.put(`lessons/${lessonId}/lock/${lockId}`)
  },
  unlock (lessonId) {
    return $http.put(`lessons/${lessonId}/unlock`)
  },
  addSharedTeacher (lessonId, teacherID) {
    return $http.post(`lessons/${lessonId}/add-teacher`, { body: { teacherID } })
  },
  removeSharedTeacher (lessonId, teacherID, notifyErrorMsg) {
    return $http.post(`lessons/${lessonId}/remove-teacher`, { body: { teacherID }, notifyErrorMsg })
  },
  fetchTemplates () {
    return $http.get('lesson-templates-for-user')
  },
  updateTemplate (template) {
    return $http.put(`lesson-template/${template.id}`, { body: template })
  },
  createTemplate (template) {
    return $http.post('lesson-template', { body: template })
  },
  deleteTemplate (templateId) {
    return $http.delete(`lesson-template/${templateId}`)
  },
  setDefaultTemplate (id, courseId) {
    return $http.put(`set-default-lesson-template/${id}/course/${courseId}`)
  },
  unsetDefaultTemplate (courseId) {
    return $http.put(`unset-default-lesson-template/course/${courseId}`)
  },
  createStructure () {
    return $http.get('lessons/create')
  },
  saveNew (lesson) {
    return $http.post('lessons', { body: lesson })
  },
  fetchByUnit (unitId, yearId, params) {
    return $http.get(`lessons-by-unit/${unitId}` + (yearId ? '?yearId=' + yearId : ''), { query: params })
  },
  fetchAdminTemplates () {
    return $http.get('lesson-templates-for-admin')
  },
  createAdminTemplate (template) {
    return $http.post('lesson-templates-for-admin', { body: template })
  },
  fetchSingleAdminTemplate (id) {
    return $http.get(`lesson-templates-for-admin/${id}`)
  },
  updateAdminTemplate (template) {
    return $http.put(`lesson-templates-for-admin/${template.id}`, { body: template })
  },
  deleteAdminTemplate (id) {
    return $http.delete(`lesson-templates-for-admin/${id}`)
  },
  activateAdminTemplate (id) {
    return $http.put(`lesson-templates-for-admin/${id}/activate`)
  },
  inactivateAdminTemplate (id) {
    return $http.put(`lesson-templates-for-admin/${id}/inactivate`)
  },
  addEditors (body) {
    return $http.put('lessons/add-editors', { body })
  },
  moveDates (lessonId, payload) {
    return $http.put(`lessons/${lessonId}/move-dates`, { body: payload })
  },
  moveToRecycleBin (body) {
    return $http.put('lessons/destroy-by-ids', { body })
  },
  removeCurrentUserFromSelectedLessons (body) {
    return $http.delete('lessons/current-user-by-ids', { body })
  },
  approveLessons (lessons) {
    const body = { lessons: Array.isArray(lessons) ? lessons : [lessons] }
    return $http.put('lessons-to-review/approve', { body })
  },
  clearReviewStatus (id) {
    return $http.delete(`lessons/${id}/review`)
  },
  clearReviewStatusBulk (body) {
    return $http.delete('lesson-review', { body })
  },
  getRecycledList (query) {
    return $http.get('lessons-recycle', { query })
  },
  restoreRecycled (body) {
    return $http.put('lessons-recycle', { body })
  },
  getLessonsList (query) {
    return $http.get('lessons', { query })
  },
  getLessonsForReview (query) {
    return $http.get('lessons-to-review', { query })
  },
  setReviewersForLessons (payload) {
    return $http.put('lesson-review/set-reviewers', { body: payload })
  },
  getCoursesForLessonList () {
    return $http.get('my-lessons-list/courses')
  },
  fetchLessonsForWeeklyCalendar({ dayStart, showLessonsInOtherCourses, showLessonsInRecycledCourses }) {
    return $http.get(`/my-lessons-calendar/week/${dayStart}`, { query: { showLessonsInOtherCourses, showLessonsInRecycledCourses } })
  },
  fetchLessonsForPrintToPdf ({ startDate, selectedCourses, showLessonsInOtherCourses, showLessonsInRecycledCourses }) {
    return $http.post('/my-lessons-calendar/week/pdf', {
      body: { startDate, selectedCourses, showLessonsInOtherCourses, showLessonsInRecycledCourses }
    })
  },
  fetchSingleLessonForWeeklyCalendar(lessonId) {
    return $http.get(`/my-lessons-calendar/week/single-lesson/${lessonId}`)
  },
  saveUserPreferencesForLessonCalendar(payload) {
    return $http.put('save-lesson-calendar-preferences', { body: payload })
  },
  fetchLessonsWithNoUnits(query) {
    return $http.get(`/curriculum-map/${query.id}/lessons-with-no-units`, { query })
  },
  createLessonPublicLink (payload) {
    return $http.post(`/lessons/${payload.id}/view-only-link`, { body: payload })
  },
  editLessonPublicLink (payload) {
    return $http.put(`/lessons/${payload.id}/view-only-link`, { body: payload })
  },
  linkUnitAssessments (id, payload) {
    return $http.put(`/lessons/${id}/link-unit-assessments`, { body: payload })
  },
  unlinkUnitAssessment (id, assessmentId) {
    return $http.delete(`/lessons/${id}/link-unit-assessment/${assessmentId}`)
  },
  deleteLessonPublicLink (query) {
    return $http.delete(`/lessons/${query.id}/view-only-link`, { query })
  },
  fetchLessonSharedLinkInfo(sharedLinkId) {
    return $http.get(`lesson/view-only-link/${sharedLinkId}`)
  },
  fetchLessonAssessmentById (lessonId, assessmentId, config = {}) {
    return $http.get(`/lessons/${lessonId}/assessments/${assessmentId}`, { ...config })
  },
  createLessonAssessment(lessonId, payload) {
    return $http.post(`/lessons/${lessonId}/assessments`, { body: payload })
  },
  updateLessonAssessment(lessonId, assessmentId, payload) {
    return $http.put(`/lessons/${lessonId}/assessments/${assessmentId}`, { body: payload })
  },
  updateLessonAssessmentStandards(lessonId, assessmentId, payload) {
    return $http.put(`/lessons/${lessonId}/assessments/${assessmentId}/standards`, { body: payload })
  },
  sortLessonAssessments(lessonId, payload) {
    return $http.put(`/lessons/${lessonId}/assessments/sort`, { body: payload })
  },
  promoteLessonAssessmentToUnit(lessonId, assessmentId, unitId, payload) {
    return $http.put(`/lessons/${lessonId}/promote-assessment/${assessmentId}/to-unit/${unitId}`, { body: payload })
  },
  copyUnitAssessmentToLesson(lessonId, assessmentId, unitId) {
    return $http.post(`/lessons/${lessonId}/copy-assessment/${assessmentId}/from-unit/${unitId}`)
  },
  deleteLessonAssessment(lessonId, assessmentId) {
    return $http.delete(`/lessons/${lessonId}/assessments/${assessmentId}`)
  }
})
